import type { ListBuilderConfiguration } from '../types';

/**
 * Client Emails Embedded list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const CLIENT_EMAILS_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'client-emails-default',
			cacheTTL: 0,
			name: 'All Emails',
			type: 'default',
			active: true,
			sortOrder: 0,
			columns: [
				{
					id: 'read-status',
					headers: [{ id: 'read-status-header', text: '' }],
					fields: [
						{
							id: 'read-status-field',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							conditionalVisibility: {
								field: 'isRead',
								condition: 'equals',
								value: false,
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'static',
									staticColor: { text: '#3b82f6' },
								},
							},
							displayStyle: 'dot',
						},
					],
					sortable: false,
					width: 30,
				},
				{
					id: 'shared-indicator',
					headers: [{ id: 'shared-indicator-header', text: '' }],
					fields: [
						{
							id: 'shared-indicator-field',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							conditionalVisibility: {
								field: 'sourceType',
								condition: 'not_equals',
								value: 'system_send',
							},
							styleConfig: {
								size: 'sm',
								iconName: 'share-nodes',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'icon',
						},
					],
					sortable: false,
					width: 30,
				},
				{
					id: 'email-date',
					headers: [{ id: 'email-date-header', text: 'Date' }],
					fields: [
						{
							id: 'date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'date',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
								formatOptions: { dateFormat: 'datetime-medium' },
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					width: 150,
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'date',
							objectTable: 'email_record',
						},
					],
				},
				{
					id: 'from-name',
					headers: [{ id: 'from-name-header', text: 'From' }],
					fields: [
						{
							id: 'from-name-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'fromName',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
						{
							id: 'from-email-line-break',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'line_break',
						},
						{
							id: 'from-email-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'fromEmail',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
					width: 180,
				},
				{
					id: 'to-recipients',
					headers: [{ id: 'to-recipients-header', text: 'To' }],
					fields: [
						{
							id: 'to-recipients-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'recipientsDisplay',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
								formatOptions: { maxLength: 40 },
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
					width: 160,
				},
				{
					id: 'subject',
					headers: [{ id: 'subject-header', text: 'Subject' }],
					fields: [
						{
							id: 'subject-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'subject',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
						{
							id: 'preview-line-break',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'line_break',
						},
						{
							id: 'preview-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'preview',
									objectTable: 'email_record',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
								formatOptions: { maxLength: 80 },
							},
							displayStyle: 'text',
						},
					],
					sortable: true,
					width: 350,
					sortFields: [
						{
							direction: 'ASC',
							fieldName: 'subject',
							objectTable: 'email_record',
						},
					],
				},
				{
					id: 'attachments',
					headers: [{ id: 'attachments-header', text: '' }],
					fields: [
						{
							id: 'attachments-field',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							conditionalVisibility: {
								field: 'hasAttachments',
								condition: 'equals',
								value: true,
							},
							styleConfig: {
								size: 'sm',
								iconName: 'paperclip',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'icon',
						},
					],
					sortable: false,
					width: 40,
				},
			],
			defaultSortId: 'column-email-date-desc',
		},
	],
	tableSorts: [
		{
			id: 'column-email-date-desc',
			name: 'Date (Newest First)',
			fields: [
				{ direction: 'DESC', fieldName: 'date', objectTable: 'email_record' },
			],
		},
		{
			id: 'column-email-date-asc',
			name: 'Date (Oldest First)',
			fields: [
				{ direction: 'ASC', fieldName: 'date', objectTable: 'email_record' },
			],
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [10, 25, 50, 100],
	},
	filters: {
		activeFilters: [
			'clientEmailSearch',
			'clientEmailDateRange',
			'clientEmailSource',
		],
		defaultFilters: {},
	},
	showResetButton: false,
	objects: [
		{
			baseUrl: '/email/:id',
			objectLabel: 'Email',
			objectTable: 'email_record',
			selectedFields: [
				{ fieldName: 'id', fieldLabel: 'ID' },
				{ fieldName: 'date', fieldLabel: 'Date' },
				{ fieldName: 'fromName', fieldLabel: 'From Name' },
				{ fieldName: 'fromEmail', fieldLabel: 'From Email' },
				{ fieldName: 'recipientsDisplay', fieldLabel: 'To' },
				{ fieldName: 'subject', fieldLabel: 'Subject' },
				{ fieldName: 'preview', fieldLabel: 'Preview' },
				{ fieldName: 'hasAttachments', fieldLabel: 'Has Attachments' },
				{ fieldName: 'isRead', fieldLabel: 'Read' },
			],
		},
	],
};
